





















helpers = require('../../helpers.coffee')

view_model =
  props: ['filters']

  components:
    verticalBar: require('./vertical_bar')

  data: ->
    done_tasks_data: {}

  methods:
    loadDoneTasksData: (filters={}) ->
      @reports_resource.doneTasks(@loadDoneTasksDataSuccess, @unkonwnError, params: {q: filters})

    loadDoneTasksDataSuccess: (data) ->
      @done_tasks_data = data.body

    increase: (service) ->
      Vue.set(@done_tasks_data, service, (if @done_tasks_data[service] then @done_tasks_data[service] + 1 else 1))

    decrease: (service) ->
      Vue.set(@done_tasks_data, service, (if @done_tasks_data[service] then @done_tasks_data[service] - 1 else 0))

  computed:
    total_quantity: ->
      @done_tasks_list.reduce ((sum, task_data) -> sum + task_data[1]), 0

    done_tasks_list: ->
      for task_service in Task.availableManualTaskServices
        [task_service.service, @done_tasks_data[task_service.service] || 0, Task.serviceIcons[task_service.service]]

  created: ->
    @reports_resource = new ReportsResource(Session.current_company.id)
    @loadDoneTasksData()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/done_tasks.vue